import { getRid } from "./rid";

export function trackPageView() {
  fetch("/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      rid: getRid(),
      referer: document.referrer || "",
      url: window.location.href,
      ua: navigator.userAgent,
    }),
    keepalive: true,
  });
}
